import React from "react";
import { Link } from "react-router-dom";
import hero1 from "../../images/hero/image-8.jpg";
import shape from "../../images/hero/flower.png";

// 🧠 Define optional props (if you want to reuse it later)
interface Hero6Props {
    title?: string;
    description?: string;
}

const Hero6: React.FC<Hero6Props> = ({
    title = "Best Wedding Gown Collection",
    description = `Discover timeless elegance and modern sophistication with our best wedding gown
  collection, curated to make every bride’s dream come true. From delicate lace details to flowing satin
  silhouettes, each gown is designed to celebrate love, beauty, and individuality.`,
}) => {
    return (
        <section className="wpo-hero-slider-s6">
            <div className="container-fluid">
                <div className="hero-wrapper">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hero-content">
                                <div
                                    className="slide-title wow fadeInLeftSlow"
                                    data-wow-duration="1200ms"
                                >
                                    <h2>{title}</h2>
                                </div>
                                <div
                                    className="hero-description wow fadeInRightSlow"
                                    data-wow-duration="1200ms"
                                >
                                    <p>{description}</p>
                                    <Link to="/shop" className="theme-btn">
                                        See Our Collection
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Decorative Circle Animation */}
                <div className="hero-circle">
                    <div className="circle-content">
                        <div className="rotate-anm">
                            <svg
                                viewBox="0 0 100 100"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                            >
                                <defs>
                                    <path
                                        id="circle1"
                                        d="M 50, 50
                       m -37, 0
                       a 37,37 0 1,1 74,0
                       a 37,37 0 1,1 -74,0"
                                    />
                                </defs>
                                <text>
                                    <textPath href="#circle1">you are invited</textPath>
                                </text>
                            </svg>
                            <div className="flower">
                                <img src={shape} alt="flower decoration" />
                            </div>
                        </div>
                        <div className="circle-big" />
                        <div className="circle-small" />
                    </div>
                </div>

                {/* Hero Image */}
                <div className="hero-image">
                    <img src={hero1} alt="Wedding Gown Collection" />
                </div>
            </div>
        </section>
    );
};

export default Hero6;
